var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card",attrs:{"data-testid":"cardjobs"}},[_c('div',{staticClass:"card__image"},[_vm._t("main-image")],2),_vm._v(" "),_c('div',{staticClass:"card__text"},[_vm._t("header"),_vm._v(" "),_vm._t("content"),_vm._v(" "),_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }